import { create } from "zustand"

export const useShowAIForm = create((set) => ({
  isOpen: undefined,
  onOpen: () => set((state) => ({ isOpen: true })),
  onClose: () => set((state) => ({ isOpen: false })),
}))
